<template>
  <div class="flex-grow-1 d-flex flex-column overflow-hidden  mt-n2">
    <!-- 查看用户子页 -->
    <template v-if="allocateUserView">
      <v-card class="rounded-xl card-bg card-bd flex-shrink-0 px-6 py-4 mb-3" variant="elevated" elevation="0">
        <div class="d-flex align-center flex-wrap ga-4">
          <v-btn variant="outlined" color="#2655f1" class="action-btn px-5" rounded="xl" @click="closeAllocateUser">
            <v-icon start icon="mdi-arrow-left" />返回
          </v-btn>
          <div class="allocate-head-meta d-flex align-center flex-wrap ga-2">
            <span class="meta-label">当前系统:</span>
            <span class="meta-value mr-4">{{ allocateRole?.systemSign || systemSign }}</span>
            <span class="meta-label">当前角色:</span>
            <span class="meta-value">{{ allocateRole?.roleName }}</span>
          </div>
        </div>
      </v-card>

      <v-card class="rounded-xl card-bg card-bd card-table flex-grow-1 d-flex flex-column overflow-hidden"
        variant="elevated" elevation="0" :loading="userListLoading">
        <div class="table-wrapper flex-grow-1 overflow-hidden d-flex flex-column">
          <v-table fixed-header height="100%" style="width: 100%; background: transparent" class="gm-table">
            <thead>
              <tr>
                <th style="width: 200px">用户名称</th>
                <th style="width: 200px">用户昵称</th>
                <th style="width: 220px">邮箱</th>
                <th style="width: 180px">手机</th>
                <th style="width: 120px">状态</th>
                <th style="width: 220px">创建时间</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="u in allocatedUsers" :key="u.userId">
                <td style="color: #2655f1; font-weight: 500">
                  {{ u.userName }}
                </td>
                <td>{{ u.nickName || "--" }}</td>
                <td>{{ u.email || "--" }}</td>
                <td>{{ userPhoneDisplay(u) }}</td>
                <td>
                  <v-chip :color="String(u.status) === '0' ? '#33BE36' : '#FF6A46'" variant="tonal" class="status-chip">
                    {{ userStatusText(u.status) }}
                  </v-chip>
                </td>
                <td class="text-medium-emphasis">
                  {{ formatDateSafe(u.createTime) }}
                </td>
              </tr>
            </tbody>
          </v-table>
        </div>
        <div v-if="!userListLoading && allocatedUsers.length === 0" class="text-center text-medium-emphasis py-8">
          暂无用户数据
        </div>
        <div class="px-6 py-4 d-flex justify-end">
          <TablePagination :total="userPageTotal" v-model="userPageNum" v-model:pageSize="userPageSize"
            @change="onUserPageChange" />
        </div>
      </v-card>
    </template>

    <template v-else>
      <!-- 搜索条件卡片 -->
      <v-card class="rounded-xl card-bg card-bd flex-shrink-0 px-6 py-5" variant="elevated" elevation="0">
        <div class="d-flex align-center flex-nowrap ga-4">
          <div class="search-item">
            <span class="search-label">角色名称</span>
            <v-text-field v-model="queryParams.roleName" placeholder="请输入角色名称" variant="outlined" density="compact"
              hide-details rounded="xl" class="search-input" @keyup.enter="handleQuery" @input="handleQuery" />
          </div>
          <div class="search-item">
            <span class="search-label">角色编码</span>
            <v-text-field v-model="queryParams.roleKey" placeholder="请输入角色编码" variant="outlined" density="compact"
              hide-details rounded="xl" class="search-input" @keyup.enter="handleQuery" @input="handleQuery" />
          </div>
          <div class="search-item">
            <span class="search-label">状态</span>
            <v-select v-model="queryParams.status" :items="statusOptions" placeholder="请选择" variant="outlined"
              density="compact" hide-details rounded="xl" class="search-input--select" clearable
              @update:model-value="handleQuery" />
          </div>

          <div class="search-actions d-flex ga-3 ml-auto">
            <v-btn color="#2655f1" rounded="xl" @click="handleQuery" class="action-btn">
              <v-icon start icon="mdi-magnify" />查询
            </v-btn>
            <v-btn variant="outlined" color="#2655f1" rounded="xl" @click="resetQuery" class="action-btn">
              <v-icon start icon="mdi-refresh" />重置
            </v-btn>
            <v-btn v-hasPermi="['system:role:add']" variant="outlined" color="#2655f1" rounded="xl"
              @click="openRoleDialog()" class="action-btn">
              <v-icon start icon="mdi-plus" />新增角色
            </v-btn>
          </div>
        </div>
      </v-card>

      <!-- 表格内容 -->
      <v-card class="rounded-xl card-bg card-bd card-table flex-grow-1 d-flex flex-column overflow-hidden mt-3"
        variant="elevated" elevation="0" :loading="listLoading">
        <div class="table-wrapper flex-grow-1 overflow-hidden d-flex flex-column">
          <v-table fixed-header height="100%" style="width: 100%; background: transparent" class="gm-table border-none">
            <thead>
              <tr>
                <th style="width: 120px">角色编号</th>
                <th style="width: 280px">角色名称</th>
                <th style="width: 200px">角色编码</th>
                <th style="width: 220px">显示顺序</th>
                <th style="width: 220px">状态</th>
                <th style="width: 220px">创建时间</th>
                <th style="width: 260px" class="text-center">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in tableRows" :key="row.roleId">
                <td class="text-medium-emphasis">0{{ row.roleId }}</td>
                <td style="color: #2655f1; font-weight: 500">
                  {{ row.roleName || "--" }}
                </td>
                <td>{{ row.roleKey || "--" }}</td>
                <td>{{ row.roleSort }}</td>
                <td>
                  <v-chip :color="String(row.status) === '1' ? '#FF6A46' : '#33BE36'" variant="tonal"
                    class="status-chip">
                    {{ statusText(row.status) }}
                  </v-chip>
                </td>
                <td class="text-medium-emphasis">
                  {{ formatDateSafe(row.createTime) }}
                </td>
                <td>
                  <div class="d-flex ga-2">
                    <v-btn v-hasPermi="['system:role:edit']" variant="text" color="#2655f1" rounded="xl"
                      @click="openRoleDialog(row)">修改</v-btn>
                    <v-btn v-hasPermi="['system:role:dataScope']" variant="text" color="#2655f1" rounded="xl"
                      @click="openDataRuleDialog(row)">数据权限</v-btn>
                    <v-btn v-hasPermi="['system:role:authUser']" variant="text" color="#2655f1" rounded="xl"
                      @click="openAllocateUser(row)">查看用户</v-btn>
                    <v-btn v-hasPermi="['system:role:remove']" variant="text" color="#FF6A46" rounded="xl"
                      @click="confirmDelete(row)">删除</v-btn>
                  </div>
                </td>
              </tr>
            </tbody>
          </v-table>
        </div>
        <div v-if="!listLoading && tableRows.length === 0" class="text-center py-12 text-medium-emphasis">
          暂无角色数据
        </div>
        <div class="px-6 pb-4 d-flex justify-end">
          <TablePagination :total="pageTotal" v-model="pageNum" v-model:pageSize="pageSize" @change="onPageChange" />
        </div>
      </v-card>
    </template>

    <!-- 新增/编辑角色弹窗 -->
    <v-dialog v-model="roleDialogVisible" max-width="740px" persistent class="gm-dialog">
      <v-card class="rounded-30 overflow-hidden dialog-card">
        <div class="gm-dialog-header d-flex align-center px-8 py-6">
          <div class="text-h5">
            <span style="color: #2655f1">{{
              roleDialogTitle.substring(0, 2)
            }}</span>
            <span>{{ roleDialogTitle.substring(2) }}</span>
          </div>
          <v-spacer />
          <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="roleDialogVisible = false" />
        </div>

        <v-card-text class="pa-8 pt-0 scrollbar-hide" style="max-height: 70vh; overflow-y: auto">
          <v-form>
            <div class="form-grid-2">
              <div class="form-group grid-full">
                <label>角色名称 <span class="required-star">*</span></label>
                <v-text-field v-model="roleForm.roleName" placeholder="请输入角色名称" variant="solo" density="compact"
                  class="gm-input" hide-details />
              </div>
              <div class="form-group grid-full">
                <label>权限字符 <span class="required-star">*</span></label>
                <v-text-field v-model="roleForm.roleKey" placeholder="请输入权限字符" variant="solo" density="compact"
                  class="gm-input" :disabled="roleDialogMode === 'edit'" hide-details />
              </div>
              <div class="form-group grid-full">
                <label>显示顺序 <span class="required-star">*</span></label>
                <v-text-field v-model.number="roleForm.roleSort" type="number" placeholder="请输入显示顺序" variant="solo"
                  density="compact" class="gm-input" hide-details />
              </div>

              <div class="form-group">
                <label>角色状态 <span class="required-star">*</span></label>
                <v-radio-group v-model="roleForm.status" inline hide-details class="gm-radio-group">
                  <div class="d-flex ga-6 w-100">
                    <v-radio label="正常" value="0" class="gm-radio-card flex-1" color="#2655F1" />
                    <v-radio label="停用" value="1" class="gm-radio-card flex-1" color="#2655F1" />
                  </div>
                </v-radio-group>
              </div>

              <div class="form-group">
                <label>角色类型</label>
                <v-radio-group v-model="roleForm.deptAdmin" inline hide-details class="gm-radio-group">
                  <div class="d-flex ga-6 w-100">
                    <v-radio label="普通用户" value="0" class="gm-radio-card flex-1" color="#2655F1" />
                    <v-radio label="管理员" value="1" class="gm-radio-card flex-1" color="#2655F1" />
                  </div>
                </v-radio-group>
              </div>

              <div class="form-group grid-full">
                <label>备注</label>
                <v-textarea v-model="roleForm.remark" placeholder="请输入备注内容" variant="solo" density="compact"
                  class="gm-input" rows="2" hide-details />
              </div>

              <div class="form-group grid-full">
                <div class="d-flex align-center ga-4">
                  <label class="mb-0">菜单权限</label>
                  <v-checkbox v-model="menuCheckAll" label="全选" density="compact" color="#2655f1" hide-details
                    @update:model-value="onMenuCheckAll" />
                  <v-checkbox v-model="roleForm.menuCheckStrictly" label="父子联动" density="compact" color="#2655f1"
                    hide-details />
                </div>
                <div class="menu-tree-box rounded-xl pa-4">
                  <el-tree v-if="roleDialogVisible" ref="menuTreeRef" :data="menuTreeData" show-checkbox node-key="id"
                    :check-strictly="!roleForm.menuCheckStrictly" :props="{ label: 'label', children: 'children' }"
                    default-expand-all style="background: transparent" />
                </div>
              </div>
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions class="px-8 pb-8 pt-0 justify-end">
          <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-10 mr-4"
            @click="roleDialogVisible = false">取消</v-btn>
          <v-btn color="#2655f1" variant="flat" class="gm-btn-primary px-10 text-white" :loading="roleSubmitLoading"
            @click="submitRole">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 删除确认弹窗 -->
    <v-dialog v-model="deleteDialogVisible" max-width="420px" persistent class="gm-dialog">
      <v-card class="rounded-30 overflow-hidden dialog-card">
        <div class="gm-dialog-header d-flex align-center px-8 py-6">
          <div class="text-h5">
            <span style="color: #3a68ff">删除</span><span>确认</span>
          </div>
          <v-spacer />
          <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="deleteDialogVisible = false" />
        </div>
        <v-card-text class="pa-8 pt-2 pb-4">
          <div class="text-body-1">确定删除「{{ deleteTargetName }}」吗？</div>
        </v-card-text>
        <v-card-actions class="px-8 pb-8 pt-0 justify-end">
          <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-10 mr-4"
            @click="deleteDialogVisible = false">取消</v-btn>
          <v-btn color="#3a68ff" variant="flat" class="gm-btn-primary px-10 text-white" :loading="deleteLoading"
            @click="doDelete">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 数据权限弹窗 -->
    <v-dialog v-model="dataRuleVisible" max-width="740px" persistent class="gm-dialog">
      <v-card class="rounded-30 overflow-hidden dialog-card">
        <div class="gm-dialog-header d-flex align-center px-8 py-6">
          <div class="text-h5">
            <span style="color: #2655f1">数据</span><span>权限</span>
          </div>
          <v-spacer /><v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)"
            @click="dataRuleVisible = false" />
        </div>
        <v-card-text class="pa-8 pt-0 scrollbar-hide" style="max-height: 68vh; overflow-y: auto">
          <div class="form-grid-2">
            <div class="form-group grid-full">
              <label>系统标识</label>
              <v-text-field :model-value="dataAuthDisplay.systemSign" variant="outlined" density="compact"
                class="gm-input" readonly hide-details />
            </div>
            <div class="form-group grid-full">
              <label>角色名称</label>
              <v-text-field :model-value="dataAuthDisplay.roleName" variant="outlined" density="compact"
                class="gm-input" readonly hide-details />
            </div>
            <div class="form-group grid-full">
              <label>权限字符</label>
              <v-text-field :model-value="dataAuthDisplay.roleKey" variant="outlined" density="compact" class="gm-input"
                readonly hide-details />
            </div>
            <div class="form-group grid-full">
              <div class="d-flex align-center ga-4 mb-3">
                <label class="mb-0">权限范围 <span class="required-star">*</span></label>
                <v-checkbox v-model="isCustomDataScope" label="自定义数据权限" density="compact" color="#2655f1" hide-details
                  @update:model-value="onCustomDataScopeChange" />
                <v-checkbox v-if="isCustomDataScope" v-model="dataDeptCheckStrictly" label="父子联动" density="compact"
                  color="#2655f1" hide-details />
              </div>
              <v-select v-if="!isCustomDataScope" v-model="dataAuthScopeSelect" :items="dataScopeItems"
                item-title="label" item-value="value" variant="outlined" density="compact" class="gm-input" hide-details
                @update:model-value="onDataScopeSelectChange" />
            </div>
            <div v-if="isCustomDataScope" class="form-group grid-full">
              <div class="d-flex align-center ga-4 mb-3">
                <label class="mb-0">数据权限 <span class="required-star">*</span></label>
                <v-checkbox v-model="dataDeptCheckAll" label="全选" density="compact" color="#2655f1" hide-details
                  @update:model-value="onDataDeptCheckAll" />
              </div>
              <div class="menu-tree-box rounded-xl pa-4">
                <el-tree ref="dataDeptTreeRef" :data="dataDeptTree" show-checkbox node-key="id"
                  :check-strictly="!dataDeptCheckStrictly" :props="{ label: 'label', children: 'children' }"
                  default-expand-all style="background: transparent" />
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="px-8 pb-8 pt-0 justify-end">
          <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-10 mr-4"
            @click="dataRuleVisible = false">取消</v-btn>
          <v-btn color="#2655f1" variant="flat" class="gm-btn-primary px-10 text-white"
            @click="saveDataRules">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, reactive, ref, watch } from "vue";
import { eui } from "ems-ui";
import TablePagination from "@/components/TablePagination/index.vue";
import { formatDate } from "@/utils";
import {
  addRoleEcenter,
  delRoleEcenter,
  getRoleDataRulesEcenter,
  getRoleMenuTreeselectEcenter,
  menuTreeselectEcenter,
  listRoleEcenter,
  listRoleUsersEcenter,
  setRoleDataRulesEcenter,
  updateRoleEcenter,
} from "@/api/ecenter";

const systemSign = "gemini3";
const pageNum = ref(1);
const pageSize = ref(10);
const pageTotal = ref(0);
const tableRows = ref<any[]>([]);
const listLoading = ref(false);
const queryParams = reactive({
  roleName: undefined,
  roleKey: undefined,
  status: undefined,
});
const statusOptions = [
  { title: "正常", value: "0" },
  { title: "停用", value: "1" },
];

async function fetchList() {
  listLoading.value = true;
  const params: any = {
    pageNum: pageNum.value,
    pageSize: pageSize.value,
    systemSign,
  };
  Object.keys(queryParams).forEach((k) => {
    if (queryParams[k as keyof typeof queryParams])
      params[k] = queryParams[k as keyof typeof queryParams];
  });
  try {
    const res: any = await listRoleEcenter(params);
    tableRows.value = res?.rows || res?.data?.rows || [];
    pageTotal.value = res?.total || res?.data?.total || 0;
  } finally {
    listLoading.value = false;
  }
}
function handleQuery() {
  pageNum.value = 1;
  fetchList();
}
function onPageChange(p: number) {
  pageNum.value = p;
  fetchList();
}
function resetQuery() {
  queryParams.roleName = undefined;
  queryParams.roleKey = undefined;
  queryParams.status = undefined;
  handleQuery();
}

const roleDialogVisible = ref(false);
const roleDialogTitle = ref("新增角色");
const roleDialogMode = ref<"add" | "edit">("add");
const roleForm = reactive<any>({
  roleId: "",
  roleName: "",
  roleKey: "",
  roleSort: 1,
  status: "0",
  deptAdmin: "0",
  remark: "",
  menuCheckStrictly: false,
});
const menuTreeData = ref<any[]>([]);
const menuTreeRef = ref<any>(null);
const roleSubmitLoading = ref(false);
const menuCheckAll = ref(false);

function onMenuCheckAll(v: boolean | null) {
  if (v) menuTreeRef.value?.setCheckedNodes(menuTreeData.value);
  else menuTreeRef.value?.setCheckedKeys([]);
}

async function openRoleDialog(row?: any) {
  roleDialogVisible.value = true;
  roleDialogMode.value = row ? "edit" : "add";
  roleDialogTitle.value = row ? "修改角色" : "新增角色";
  menuCheckAll.value = false;
  Object.assign(roleForm, {
    roleId: "",
    roleName: "",
    roleKey: "",
    roleSort: 1,
    status: "0",
    deptAdmin: "0",
    remark: "",
    menuCheckStrictly: false,
  });
  const res: any = await menuTreeselectEcenter({ systemSign });
  menuTreeData.value = res?.data || res?.rows || [];
  await nextTick();
  menuTreeRef.value?.setCheckedKeys([]);
  if (row) {
    const detail: any = await getRoleMenuTreeselectEcenter(row.roleId, {
      systemSign,
    });
    const r = detail?.data?.role || detail?.role || row || {};
    const checkedKeys = detail?.data?.checkedKeys || detail?.checkedKeys || [];
    Object.assign(roleForm, {
      ...r,
      roleId: r?.roleId ?? row?.roleId ?? "",
      roleName: r?.roleName ?? row?.roleName ?? "",
      roleKey: r?.roleKey ?? row?.roleKey ?? "",
      roleSort: Number(r?.roleSort ?? row?.roleSort ?? 1),
      status: String(r?.status ?? row?.status ?? "0"),
      deptAdmin: String(r?.deptAdmin ?? row?.deptAdmin ?? "0"),
      remark: r?.remark ?? row?.remark ?? "",
      menuCheckStrictly: Boolean(r?.menuCheckStrictly ?? false),
    });
    await nextTick();
    checkedKeys.forEach((k: any) => menuTreeRef.value?.setChecked(k, true, false));
  } else {
    roleForm.menuCheckStrictly = false;
  }
}
/** 与 ecenter-ui getMenuAllCheckedKeys：半选父节点 + 全选节点，顺序一致 */
function getMenuAllCheckedKeysForSubmit() {
  const tree = menuTreeRef.value;
  if (!tree?.getCheckedKeys) return [];
  const checkedKeys = [...(tree.getCheckedKeys() || [])];
  const halfCheckedKeys = tree.getHalfCheckedKeys?.() || [];
  checkedKeys.unshift(...halfCheckedKeys);
  return checkedKeys;
}

async function submitRole() {
  const payload = {
    ...roleForm,
    systemSign,
    menuIds: getMenuAllCheckedKeysForSubmit(),
  };
  roleSubmitLoading.value = true;
  try {
    if (roleDialogMode.value === "edit") await updateRoleEcenter(payload);
    else await addRoleEcenter(payload);
    roleDialogVisible.value = false;
    fetchList();
  } finally {
    roleSubmitLoading.value = false;
  }
}
const deleteDialogVisible = ref(false);
const deleteLoading = ref(false);
const deleteTargetRow = ref<any>(null);
const deleteTargetName = computed(() => deleteTargetRow.value?.roleName || "");

function confirmDelete(row: any) {
  deleteTargetRow.value = row;
  deleteDialogVisible.value = true;
}

async function doDelete() {
  if (!deleteTargetRow.value) return;
  deleteLoading.value = true;
  try {
    await delRoleEcenter(deleteTargetRow.value.roleId);
    deleteDialogVisible.value = false;
    fetchList();
  } finally {
    deleteLoading.value = false;
  }
}

const dataRuleVisible = ref(false);
const dataAuthScopeSelect = ref("5");
const dataAuthDisplay = reactive({ roleName: "", roleKey: "", systemSign });
const dataAuthRoleId = ref<string | number>("");
const isCustomDataScope = ref(false);
const dataDeptTree = ref<any[]>([]);
const dataDeptTreeRef = ref<any>(null);
const dataDeptCheckStrictly = ref(false);
const dataDeptCheckAll = ref(false);
const dataScopeItems = [
  { value: "1", label: "所有数据权限" },
  { value: "3", label: "本部门数据权限" },
  { value: "4", label: "本部门及以下数据权限" },
  { value: "5", label: "仅本人数据权限" },
];
watch(dataAuthScopeSelect, (v) => {
  if (String(v) !== "2") isCustomDataScope.value = false;
});
function onCustomDataScopeChange(v: boolean | null) {
  isCustomDataScope.value = !!v;
  if (isCustomDataScope.value) dataAuthScopeSelect.value = "2";
  else if (dataAuthScopeSelect.value === "2") dataAuthScopeSelect.value = "1";
}
function onDataScopeSelectChange(v: string) {
  if (String(v) !== "2") isCustomDataScope.value = false;
}
function onDataDeptCheckAll(v: boolean | null) {
  if (v) dataDeptTreeRef.value?.setCheckedNodes(dataDeptTree.value);
  else dataDeptTreeRef.value?.setCheckedKeys([]);
}
function getDataDeptAllCheckedKeys() {
  const checkedKeys = dataDeptTreeRef.value?.getCheckedKeys?.() || [];
  const halfCheckedKeys = dataDeptTreeRef.value?.getHalfCheckedKeys?.() || [];
  return [...new Set([...halfCheckedKeys, ...checkedKeys])];
}
async function openDataRuleDialog(row: any) {
  dataRuleVisible.value = true;
  dataAuthDisplay.roleName = row.roleName || "";
  dataAuthDisplay.roleKey = row.roleKey || "";
  dataAuthDisplay.systemSign = row.systemSign || systemSign;
  dataAuthRoleId.value = row.roleId;
  dataDeptCheckAll.value = false;
  dataDeptTree.value = [];
  dataDeptCheckStrictly.value = false;
  try {
    const detail: any = await getRoleDataRulesEcenter(row.roleId, { systemSign });
    const role = detail?.role || detail?.data?.role || row;
    const checkedKeys = detail?.checkedKeys || detail?.data?.checkedKeys || [];
    dataDeptTree.value = detail?.depts || detail?.data?.depts || [];
    dataAuthDisplay.roleName = role?.roleName || row.roleName || "";
    dataAuthDisplay.roleKey = role?.roleKey || row.roleKey || "";
    dataAuthDisplay.systemSign = role?.systemSign || row.systemSign || systemSign;
    dataAuthScopeSelect.value = String(role?.dataScope ?? row?.dataScope ?? "5");
    isCustomDataScope.value = dataAuthScopeSelect.value === "2";
    dataDeptCheckStrictly.value = !!role?.deptCheckStrictly;
    dataAuthRoleId.value = role?.roleId ?? row.roleId;
    await nextTick();
    dataDeptTreeRef.value?.setCheckedKeys([]);
    checkedKeys.forEach((k: any) => dataDeptTreeRef.value?.setChecked(k, true, false));
  } catch {
    dataAuthScopeSelect.value = String(row?.dataScope ?? "5");
    isCustomDataScope.value = dataAuthScopeSelect.value === "2";
  }
}
async function saveDataRules() {
  if (!dataAuthRoleId.value) return;
  // 与 ecenter putDataAuth：自定义范围时固定 dataScope 为 2
  const dataScope = isCustomDataScope.value ? "2" : String(dataAuthScopeSelect.value);
  await setRoleDataRulesEcenter({
    roleId: dataAuthRoleId.value,
    dataScope,
    deptIds: isCustomDataScope.value ? getDataDeptAllCheckedKeys() : [],
    deptCheckStrictly: isCustomDataScope.value ? dataDeptCheckStrictly.value : false,
    systemSign,
  });
  dataRuleVisible.value = false;
  fetchList();
}

function formatDateSafe(v: any) {
  return v ? formatDate(v) : "--";
}
function statusText(s: any) {
  return String(s) === "1" ? "停用" : "正常";
}
function dataScopeText(s: any) {
  return dataScopeItems.find((i) => i.value === String(s))?.label || "--";
}

const allocateUserView = ref(false);
const allocateRole = ref<any>(null);
const allocatedUsers = ref<any[]>([]);
const userPageNum = ref(1);
const userPageSize = ref(10);
const userPageTotal = ref(0);
const userListLoading = ref(false);
async function fetchAllocatedUsers() {
  userListLoading.value = true;
  try {
    const res: any = await listRoleUsersEcenter({
      roleId: allocateRole.value.roleId,
      pageNum: userPageNum.value,
      pageSize: userPageSize.value,
      systemSign,
    });
    allocatedUsers.value = res?.rows || [];
    userPageTotal.value = res?.total || 0;
  } finally {
    userListLoading.value = false;
  }
}
function onUserPageChange(p: number) {
  userPageNum.value = p;
  fetchAllocatedUsers();
}
function openAllocateUser(row: any) {
  allocateRole.value = row;
  allocateUserView.value = true;
  fetchAllocatedUsers();
}
function closeAllocateUser() {
  allocateUserView.value = false;
}
function userStatusText(s: any) {
  return String(s) === "0" ? "正常" : "停用";
}
function userPhoneDisplay(u: any) {
  return u.phonenumber || "--";
}
function menuTypeLabel(t: any) {
  return t === "M" ? "目录" : t === "C" ? "菜单" : "按钮";
}
function getMenuTypeColor(t: any) {
  return t === "M" ? "#2655f1" : "#2DAE55";
}

fetchList();
</script>

<style scoped lang="scss">
.card-bg {
  background: #fff;
  backdrop-filter: blur(8px);
}

.card-bd {
  border-radius: 0 0 30px 30px !important;
}

.card-table {
  padding: 24px 16px 0;
  border-radius: 30px !important;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;

  .search-label {
    white-space: nowrap;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.7);
  }

  .search-input {
    width: 220px;
  }

  .search-input--select {
    width: 220px;
  }
}

.action-btn {
  min-width: 90px;
  height: 40px !important;
}

.gm-table {
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;

  :deep(.v-table__wrapper) {
    overflow-x: auto !important;
  }

  :deep(thead tr) {
    background: #f8fafc !important;
  }

  :deep(th) {
    font-weight: 600 !important;
    color: rgba(0, 0, 0, 0.8) !important;
    border: none !important;
    background: #f8fafc !important;
    height: 56px !important;
    padding: 0 24px !important;
    white-space: nowrap;
  }

  :deep(td) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.04) !important;
    height: 56px !important;
    padding: 0 24px !important;
    white-space: nowrap;
  }
}

.gm-dialog {
  :deep(.v-overlay__content) {
    border-radius: 30px !important;
  }
}

.dialog-card {
  border-radius: 30px !important;
  background: #fff;
}

.gm-dialog-header {
  background: linear-gradient(185deg, #2655f160 0%, #fff0 60%);
  position: relative;

  .text-h5 {
    font-size: 24px !important;
    letter-spacing: 0.5px;
    font-weight: 500;
  }
}

.gm-input {
  :deep(.v-field) {
    background-color: rgba(239, 244, 251, 0.7) !important;
    border-radius: 15px !important;
    box-shadow: none !important;
    padding-inline: 4px !important;

    .v-field__outline {
      display: none !important;
    }

    input {
      font-size: 14px;
      color: rgba(46, 46, 46, 0.8);
    }
  }

  &.v-input--focused :deep(.v-field) {
    border-color: #2655f1 !important;
  }
}

.gm-radio-group {
  :deep(.v-selection-control-group) {
    width: 100%;
  }
}

.gm-radio-card {
  flex: 1;
  height: 42px;
  background-color: rgba(239, 244, 251, 0.7) !important;
  border-radius: 15px !important;
  transition: all 0.2s ease !important;
  cursor: pointer;
  display: flex !important;
  align-items: center;
  justify-content: center;

  :deep(.v-selection-control) {
    width: 100%;
    height: 100%;
    margin: 0 !important;
    padding: 0 !important;

    .v-selection-control__wrapper {
      display: none;
    }
  }

  &.v-selection-control--active {
    background-color: #2655f1 !important;
    box-shadow: 0 4px 12px rgba(38, 85, 241, 0.2) !important;

    :deep(.v-label) {
      color: #fff !important;
      font-weight: 600 !important;
    }
  }
}

:deep(.v-label) {
  font-size: 14px !important;
  color: #2e2e2e;
  margin: 0 !important;
}


.form-grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.grid-full {
  grid-column: span 2;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 10px;

  label {
    font-size: 14px;
    font-weight: 500;
    color: #2e2e2e;
  }
}

.menu-tree-box {
  max-height: 380px;
  overflow-y: auto;
  background: rgba(239, 244, 251, 0.4);
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-radius: 15px;

  :deep(.el-checkbox__input.is-checked .el-checkbox__inner) {
    background-color: rgb(38, 85, 241) !important;
    border-color: rgb(38, 85, 241) !important;
  }

  :deep(.el-checkbox__input.is-checked + .el-checkbox__label) {
    color: rgb(38, 85, 241) !important;
  }
}

.status-chip {
  // font-weight: 600;
  min-width: 60px;
  height: 28px !important;
  line-height: 28px !important;
  justify-content: center;
  border: 1px solid currentColor !important;
}

.gm-btn-primary,
.gm-btn-secondary {
  height: 42px !important;
  border-radius: 12px !important;
  font-size: 16px !important;
}

.allocate-head-meta {
  font-size: 14px;
  line-height: 1.2;
}

.meta-label {
  color: rgba(0, 0, 0, 0.6);
}

.meta-value {
  color: #2655f1;
  font-weight: 600;
}

.required-star {
  color: #ff4d4f;
}
</style>
